import { z } from "zod";
const RawGtvSchema = z.union([
    z.boolean(),
    z.string(),
    z.number(),
    z.bigint(),
    z.instanceof(Buffer),
    z.array(z.unknown()),
    z.record(z.unknown()),
]);
const DictPairSchema = z.record(RawGtvSchema);
const TransactionInfoInBlockResponseSchema = z.object({
    rid: z.string(),
    hash: z.string(),
    data: z.string().optional(),
});
const BlockInfoResponseSchema = z.object({
    rid: z.string(),
    prevBlockRID: z.string(),
    header: z.string(),
    height: z.number(),
    transactions: z.array(TransactionInfoInBlockResponseSchema),
    witness: z.string(),
    witnesses: z.array(z.string()),
    timestamp: z.number(),
});
const TransactionObjectSchema = z.object({
    tx: z.string(),
});
const TransactionsCountSchema = z.object({
    transactionsCount: z.number(),
});
const TransactionConfirmationProofSchema = z.object({
    proof: z.string(),
});
const ConfirmationProofSchema = z.object({
    hash: z.instanceof(Buffer),
    blockHeader: z.instanceof(Buffer),
    witness: z.instanceof(Buffer),
    merkleProofTree: RawGtvSchema,
    txIndex: z.number(),
});
const TransactionInfoResponseSchema = z.object({
    blockRID: z.string(),
    blockHeight: z.number(),
    blockHeader: z.string(),
    witness: z.string(),
    timestamp: z.number(),
    txRID: z.string(),
    txHash: z.string(),
    txData: z.string(),
});
const TransactionInfoSchema = z.object({
    blockRid: z.instanceof(Buffer),
    blockHeight: z.number(),
    blockHeader: z.instanceof(Buffer),
    witness: z.instanceof(Buffer),
    timestamp: z.number(),
    txRid: z.instanceof(Buffer),
    txHash: z.instanceof(Buffer),
    txData: z.instanceof(Buffer),
});
const RejectedTransactionSchema = z.object({
    txRid: z.instanceof(Buffer),
    rejectReason: z.string(),
    rejectTimestamp: z.number(),
});
const RejectedTransactionResponseSchema = z.object({
    txRID: z.string(),
    rejectReason: z.string(),
    rejectTimestamp: z.number(),
});
export function isString(value) {
    const result = z.string().safeParse(value);
    return result.success ? value : null;
}
export function isDictPair(value) {
    const result = DictPairSchema.safeParse(value);
    return result.success ? value : null;
}
export function isRawGtv(value) {
    const result = RawGtvSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfoInBlockResponse(value) {
    const result = TransactionInfoInBlockResponseSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfoInBlockResponseArray(value) {
    const result = z.array(TransactionInfoInBlockResponseSchema).safeParse(value);
    return result.success ? value : null;
}
export function isBlockInfoResponse(value) {
    const result = BlockInfoResponseSchema.safeParse(value);
    return result.success ? value : null;
}
export function isBlockInfoResponseArray(value) {
    const result = z.array(BlockInfoResponseSchema).safeParse(value);
    return result.success ? value : null;
}
export function isTransaction(value) {
    const result = TransactionObjectSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionsCount(value) {
    const result = TransactionsCountSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionConfirmationProof(value) {
    const result = TransactionConfirmationProofSchema.safeParse(value);
    return result.success ? value : null;
}
export function isConfirmationProof(value) {
    const result = ConfirmationProofSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfoResponse(value) {
    const result = TransactionInfoResponseSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfoResponseArray(value) {
    const result = z.array(TransactionInfoResponseSchema).safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfo(value) {
    const result = TransactionInfoSchema.safeParse(value);
    return result.success ? value : null;
}
export function isTransactionInfoArray(value) {
    const result = z.array(TransactionInfoSchema).safeParse(value);
    return result.success ? value : null;
}
export function isRejectedTransaction(value) {
    const result = RejectedTransactionSchema.safeParse(value);
    return result.success ? value : null;
}
export function isRejectedTransactionArray(value) {
    const result = z.array(RejectedTransactionSchema).safeParse(value);
    return result.success ? value : null;
}
export function isRejectedTransactionResponse(value) {
    const result = RejectedTransactionResponseSchema.safeParse(value);
    return result.success ? value : null;
}
export function isRejectedTransactionResponseArray(value) {
    const result = z.array(RejectedTransactionResponseSchema).safeParse(value);
    return result.success ? value : null;
}
//# sourceMappingURL=requests.js.map